import React, { Component } from "react";
import WasteTopBanner from "./wastetopbanner";

class GlassWasteTopBanner extends Component {
  render() {
    return (
      <div className="topBannerContainer">
        <div
          className="generalwaste firstSegment"
          aria-label="General Waste Collection"
          src="/generalwasteBanner.jpg"
          alt="General Waste Collection"
        >
          <WasteTopBanner />
        </div>
      </div>
    );
  }
}

export default GlassWasteTopBanner;
